import React, { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Checkbox, Form, Input, message, Modal } from 'antd';
import useToggle from '../../../hooks/useToggle';
import LanguageInput from '../../../components/LanguagesInput';
import Uploader from '../../../containers/shared/Uploader';
import { normFile } from '../../../utils';
import { useUpdateLegalDocumentsMutation } from '../../../store/apis/administratives/legalDocuments';

const Edit = ({
  initialValues,
  id,
}) => {
  const [t] = useTranslation();
  const [isOpen, open, close] = useToggle();

  const [form] = Form.useForm();

  const [
    updateDocument,
    {
      isLoading: isUpdateDocumentLoading,
      isFetching: isUpdateDocumentFetching,
    },
  ] = useUpdateLegalDocumentsMutation();

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      await updateDocument({ id, body: values }).unwrap();
      message.success(t('Документ изменен'));
      close();
      form.resetFields();
    } catch (e) {
      console.log(JSON.stringify(e, 0, 2));
    }
  }, [close, updateDocument, form, t, id]);

  const handleClose = useCallback(() => {
    form.resetFields();
    close();
  }, [close, form]);

  useEffect(() => {
    console.log(form.getFieldsValue());
  }, [form]);

  return (
    <>
      <Button
        htmlType="button"
        type="primary"
        onClick={open}
      >
        {t('Редактировать главные данные документа')}
      </Button>
      <Modal
        open={isOpen}
        title={t('Создать документ')}
        onOk={handleSubmit}
        onCancel={handleClose}
        okText={t('Создать')}
        cancelText={t('Отменить')}
        destroyOnClose
      >
        <Form
          form={form}
          layout="vertical"
          initialValues={initialValues}
          disabled={isUpdateDocumentLoading || isUpdateDocumentFetching}
        >
          <Form.Item
            label={t('Название документа')}
            required
            rules={[{ required: true }]}
            style={{ marginBottom: 0 }}
            name="header"
          >
            <LanguageInput name="header" />
          </Form.Item>
          <Form.Item name="isPublic" valuePropName="checked">
            <Checkbox>{t('Опубликован?')}</Checkbox>
          </Form.Item>
          <Form.Item
            label={t('Системное название')}
            name="alias"
            required
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t('PDF файл')}
            name="pdfPath"
            getValueFromEvent={normFile}
            required
            rules={[{ required: true }]}
          >
            <Uploader
              maxCount={1}
              multiple={false}
              group="legal_documents"
            />
          </Form.Item>
          <div style={{ marginBottom: 12 }}>
            {t('Сейчас')}: <a href={initialValues.pdfUrl} download>{initialValues.pdfUrl}</a>
          </div>
          <Form.Item
            label={t('DOCX файл')}
            name="docxPath"
            getValueFromEvent={normFile}
            required
            rules={[{ required: true }]}
          >
            <Uploader
              maxCount={1}
              multiple={false}
              group="legal_documents"
            />
          </Form.Item>
          <div>
            {t('Сейчас')}: <a href={initialValues.docxUrl} download>{initialValues.docxUrl}</a>
          </div>
        </Form>
      </Modal>
    </>
  );
};

export default Edit;
